class ShoppableVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('[ref="toggleMediaButton"]');
    this.muteButton = this.querySelector('[ref="toggleMuteButton"]');

    if (!this.video) return;

    // Browser requires muted autoplay, so start muted
    this.isMuted = this.video.muted = true;
    this.isPlaying = !this.video.paused;

    this.playButton?.addEventListener('click', () => this.togglePlayPause());
    this.muteButton?.addEventListener('click', () => this.toggleMute());

    this.updateUI();
  }

  togglePlayPause() {
    if (this.video.paused) {
      this.video.play().catch((e) => console.warn('Play failed:', e));
      this.isPlaying = true;
    } else {
      this.video.pause();
      this.isPlaying = false;
    }
    this.updateUI();
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    this.video.muted = this.isMuted;
    this.updateUI();
  }

  updateUI() {
    this.playButton?.querySelector('.icon-play')?.classList.toggle('hidden', this.isPlaying);
    this.playButton?.querySelector('.icon-pause')?.classList.toggle('hidden', !this.isPlaying);

    this.muteButton?.querySelector('.icon-mute')?.classList.toggle('hidden', !this.isMuted);
    this.muteButton?.querySelector('.icon-unmute')?.classList.toggle('hidden', this.isMuted);
  }
}

if (!customElements.get('shoppable-video')) {
  customElements.define('shoppable-video', ShoppableVideo);
}

if (!window.customElements.get('video-carousel')) {
    class VideoCarousel extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.id;
        this.spaceBetween = parseFloat(this.dataset.spaceBetween || 0);
        this.items = parseFloat(this.dataset.items);
        this.mobileItems = parseFloat(this.dataset.mobileItems);
        this.enableSlider = this.hasAttribute('enable-desktop-slider');
        this.enableMobileSlider = this.hasAttribute('enable-mobile-slider');
      }

      connectedCallback() {
        const isMobile = window.matchMedia('(max-width: 750px)').matches;

        if ((isMobile && this.enableMobileSlider) || (!isMobile && this.enableSlider)) {
          if (window.Swiper) {
            this.mountSlider();
          } else {
            window.loadSwiper().then(() => this.mountSlider());
          }
        }
      }

      mountSlider() {
        this.wrapper = this.querySelector('.swiper-wrapper');
        if (this.wrapper) this.wrapper.classList.remove('image-carousel--wrapper');

        new Swiper(`#section-${this.sectionId} .swiper`, {
          slidesPerView: this.mobileItems,
          spaceBetween: this.spaceBetween,
          breakpoints: {
            751: {
              slidesPerView: this.items,
            },
          },
          navigation: {
            nextEl: `#section-${this.sectionId} .slideshow-control--next`,
            prevEl: `#section-${this.sectionId} .slideshow-control--previous`,
          },
        });
      }
    }
    window.customElements.define('video-carousel', VideoCarousel);
  }